import { render, staticRenderFns } from "./create-sales-profile.vue?vue&type=template&id=6faabc22&scoped=true"
import script from "./create-sales-profile.vue?vue&type=script&lang=js"
export * from "./create-sales-profile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6faabc22",
  null
  
)

export default component.exports